export const MuiCheckbox = {
  styleOverrides: {
    root: {
      width: '18px',
      height: '18px',
      color: '#9F9F9F',

      '&.Mui-checked': {
        color: '#018094',

        '&:hover': {
          background: 'none',
        },
      },

      '&:hover': {
        background: 'none',
      },

      '&.Mui-focusVisible': {
        boxShadow: '0 0 15px #F16152',
      },
    },
  },
};
